import { render, staticRenderFns } from "./MoleculeEditionProductTrackingCodesCreate.vue?vue&type=template&id=be72710c&"
import script from "./MoleculeEditionProductTrackingCodesCreate.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionProductTrackingCodesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports